<template>
  <div class="bg-purple-light">
    <div class="content">
      <Navbar :is-logged-in="false" />

      <div class="d-flex justify-content-center">
        <div class="white-box my-5">
          <div class="m-3 p-4">
            <div class="dynamic-form">
              <p class="text-one mb-2">
                <strong>{{ $t("company-detail.text-one") }}</strong>
              </p>
              <p class="text-two">
                {{ $t("company-detail.text-two") }}
              </p>
              <div class="form-group p-2">
                <label>
                  {{ $t("company-detail.label.company") }}
                </label>
                <v-select
                  v-model="company"
                  class="sm"
                  :placeholder="$t('company-detail.company.label')"
                  :options="companyType"
                  :get-option-label="getCompanyLabel"
                  :reduce="getReduceValue"
                  :clearable="false"
                  :class="{'border border-danger rounded': $v.company.$error}"
                />
                <small
                  v-if="$v.company.$error && !$v.company.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.company-required') }}
                </small>
                <div
                  v-if="show.nik === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.nik") }}
                  </label>
                  <input
                    v-model.trim="$v.form.nik.$model"
                    type="text"
                    class="form-control form-control-sm col-12 text-input"
                    :placeholder="$t('company-detail.placeholder.nik')"
                    :class="{
                      'is-invalid': $v.form.nik.$error
                    }"
                  >
                  <div class="text-danger">
                    <small
                      v-if="
                        !$v.form.nik.required && $v.form.nik.$error === true
                      "
                    >{{ $t("company-detail.form-error.nik-required") }}</small>
                    <small v-if="!$v.form.nik.maxLength">{{
                      $t("company-detail.form-error.nik-maxlength")
                    }}</small>
                  </div>
                </div>
                <div
                  v-if="show.companyOwner === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.company-owner") }}
                  </label>
                  <v-select
                    v-model="form.companyOwner"
                    class="sm"
                    label="name"
                    :placeholder="$t('company-detail.placeholder.company-owner')"
                    :options="dataApi.companyOwner"
                    :reduce="getReduceId"
                    :clearable="false"
                    :class="{'border border-danger rounded': $v.form.companyOwner.$error}"
                  />
                </div>
                <small
                  v-if="$v.form.companyOwner.$error && !$v.form.companyOwner.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.companyowner-required') }}
                </small>
                <div
                  v-if="show.companyLocation === true"
                  class="companyLocation mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.company-location") }}
                  </label>
                  <v-select
                    v-model="form.companyLocation"
                    class="sm"
                    label="name"
                    :placeholder="$t('company-detail.placeholder.company-location')"
                    :options="dataApi.companyLocation"
                    :reduce="getReduceId"
                    :clearable="false"
                    :disabled="dataApi.companyLocation.length === 0"
                    :class="{'border border-danger rounded': $v.form.companyLocation.$error}"
                  />
                </div>
                <small
                  v-if="$v.form.companyLocation.$error && !$v.form.companyLocation.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.companylocation-required') }}
                </small>
                <div
                  v-if="show.companyName === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.company-name") }}
                  </label>
                  <v-select
                    v-model="form.companyName"
                    class="sm"
                    label="name"
                    :placeholder="$t('company-detail.placeholder.company-name')"
                    :options="dataApi.companyName"
                    :reduce="getReduceId"
                    :disabled="dataApi.companyName.length === 0"
                    :clearable="false"
                  />
                </div>
                <div
                  v-if="show.locationExist === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.location-exist") }}
                  </label>
                  <v-select
                    v-model="form.locationExist"
                    class="sm"
                    label="name"
                    :placeholder="$t('company-detail.placeholder.location-exist')"
                    :options="dataApi.locationExist"
                    :reduce="getReduceName"
                    :clearable="false"
                    :selectable="option => !option.hasOwnProperty('group')"
                    :class="{'border border-danger rounded': $v.form.locationExist.$error}"
                    :disabled="dataApi.locationExist.length === 0"
                  >
                    <template #option="{ group, name }">
                      <div v-if="group">
                        {{ group }}
                      </div>
                      {{ name }}
                    </template>
                  </v-select>
                </div>
                <small
                  v-if="$v.form.locationExist.$error && !$v.form.locationExist.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.locationexist-required') }}
                </small>
                <div
                  v-if="show.workUnit === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.work-unit") }}
                  </label>
                  <v-select
                    v-model="form.workUnit"
                    class="sm"
                    label="workUnitName"
                    :placeholder="$t('company-detail.placeholder.work-unit')"
                    :options="dataApi.workUnit"
                    :reduce="getWorkUnitName"
                    :clearable="false"
                    :class="{'border border-danger rounded': $v.form.workUnit.$error}"
                  />
                </div>
                <small
                  v-if="$v.form.workUnit.$error && !$v.form.workUnit.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.workunit-required') }}
                </small>
                <div
                  v-if="show.pcr === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.pcr") }}
                  </label>
                  <div
                    class="input-group"
                    :class="{'border border-danger rounded': $v.form.pcr64.$error}"
                  >
                    <div class="input-group-prepend">
                      <span class="input-group-text bg-white">
                        <img
                          src="@/assets/icon/upload.png"
                          alt="upload"
                        >
                      </span>
                    </div>
                    <input
                      id="file"
                      ref="file"
                      type="file"
                      accept="application/pdf"
                      @change="onFileChange"
                    >
                    <label
                      for="file"
                      class="form-control form-control-sm bg-white pointer"
                    >
                      {{ selectedFile ? selectedFile.name : $t('company-detail.placeholder.pcr') }}
                    </label>
                  </div>
                </div>
                <small
                  v-if="$v.form.pcr64.$error && !$v.form.pcr64.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.pcr-required') }}
                </small>
                <div
                  v-if="show.visitDate === true"
                  class="mt-3"
                >
                  <label>
                    {{ $t("company-detail.label.visit-date") }}
                  </label>
                  <div
                    class="input-group"
                    :class="{'border border-danger': $v.form.visitDate.$error}"
                  >
                    <div class="pointer input-group-prepend">
                      <date-picker
                        v-model="form.visitDate"
                        :model-config="modelConfig"
                        class="date-pick"
                      >
                        <template v-slot="{ togglePopover }">
                          <span
                            class="input-group-text bg-white text-info rounded-left"
                            @click="togglePopover({ placement: 'auto-start' })"
                          >
                            <i
                              class="fa fa-calendar"
                              aria-hidden="true"
                            />
                          </span>
                        </template>
                      </date-picker>
                    </div>
                    <input
                      v-model="form.visitDate"
                      type="text"
                      class="form-control form-control-sm bg-white"
                      placeholder="dd/mm/yyyy"
                      disabled
                    >
                  </div>
                </div>
                <small
                  v-if="$v.form.visitDate.$error && !$v.form.visitDate.required"
                  class="text-danger"
                >
                  {{ $t('company-detail.form-error.visit-date-required') }}
                </small>
              </div>
            </div>
            <div class="button text-center mt-5 row">
              <div class="col-6 p-0 pl-3 pr-2">
                <div
                  class="previous p-0 py-2"
                  @click="previousPage()"
                >
                  <strong>{{ $t("company-detail.button.previous") }}</strong>
                </div>
              </div>
              <div class="col-6 p-0 pr-3 pl-2">
                <div
                  v-if="loadingSubmit == true"
                  class="next p-0 py-2"
                >
                  <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="sr-only">
                      Loading...
                    </span>
                  </div>
                </div>
                <div
                  v-if="loadingSubmit == false"
                  class="next p-0 py-2"
                  @click="submitForm"
                >
                  <strong>
                    {{ $t("company-detail.button.finish") }}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import VSelect from 'vue-select'
import { COMPANY_TYPE } from '@/fixtures'
import DatePicker from 'v-calendar'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import Api from '@/utils/Api'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

export default {
  name: 'Companydetail',

  components: {
    Navbar,
    VSelect,
    DatePicker,
    ModalUnsuccessful
  },

  data () {
    return {
      user: JSON.parse(localStorage.getItem('profile')) || {},
      loadingSubmit: false,
      company: '',
      modelConfig: {
        type: 'string',
        mask: 'YYYY/MM/DD'
      },
      selectedFile: '',
      form: {
        nik: '',
        companyOwner: '',
        companyName: '',
        companyLocation: '',
        workUnit: '',
        locationExist: '',
        pcr: '',
        pcr64: '',
        visitDate: ''
      },
      show: {
        nik: false,
        companyOwner: false,
        companyName: false,
        companyLocation: false,
        workUnit: false,
        locationExist: false,
        pcr: false,
        visitDate: false
      },
      dataApi: {
        companyOwner: [],
        companyName: [],
        companyLocation: [],
        workUnit: [],
        locationExist: []
      },
      modal: {
        unsuccessful: false,
        textModal: ''
      }
    }
  },

  computed: {
    companyType: () => COMPANY_TYPE
  },

  watch: {
    company () {
      this.form.nik = ''
      this.form.companyOwner = ''
      this.form.companyName = ''
      this.form.companyLocation = ''
      this.form.workUnit = ''
      this.form.locationExist = ''
      this.form.pcr = ''
      this.form.pcr64 = ''
      this.selectedFile = ''
      this.form.visitDate = ''
      this.dataApi.companyName = []
      this.dataApi.companyLocation = []
      this.dataApi.locationExist = []
      switch (this.company) {
        case 'ITM Group':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = false
          this.show.locationExist = true
          this.show.workUnit = true
          this.show.pcr = false
          this.show.visitDate = false
          this.form.nik = ''
          this.$v.$reset()
          break
        case 'Contractor':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = true
          this.show.locationExist = true
          this.show.workUnit = true
          this.show.pcr = false
          this.show.visitDate = false
          this.form.nik = ''
          this.$v.$reset()
          break
        case 'BOC (Board of Commisioner)':
          this.show.nik = false
          this.show.companyOwner = false
          this.show.companyLocation = false
          this.show.companyName = false
          this.show.locationExist = false
          this.show.workUnit = false
          this.show.pcr = false
          this.show.visitDate = false
          this.form.nik = 'null'
          this.$v.$reset()
          break
        case 'Vendor':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = true
          this.show.locationExist = true
          this.show.workUnit = true
          this.show.pcr = false
          this.show.visitDate = false
          this.form.nik = ''
          this.$v.$reset()
          break
        case 'Apperentice':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = false
          this.show.locationExist = true
          this.show.pcr = false
          this.show.visitDate = false
          this.show.workUnit = false
          this.form.nik = ''
          this.$v.$reset()
          break
        case 'Outsource':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = false
          this.show.locationExist = true
          this.show.workUnit = false
          this.show.pcr = false
          this.show.visitDate = false
          this.form.nik = ''
          this.$v.$reset()
          break
        case 'Guest':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = true
          this.show.locationExist = true
          this.show.workUnit = false
          this.show.pcr = true
          this.show.visitDate = true
          this.form.nik = ''
          this.$v.$reset()
          break
        case 'Other':
          this.show.nik = true
          this.show.companyOwner = true
          this.show.companyLocation = true
          this.show.companyName = false
          this.show.locationExist = true
          this.show.workUnit = false
          this.show.pcr = false
          this.show.visitDate = false
          this.form.nik = ''
          this.$v.$reset()
          break
      }
    },
    'form.companyOwner' () {
      if (this.form.companyOwner) {
        this.form.companyLocation = ''
        this.form.locationExist = ''
        this.getCompanyName(this.form.companyOwner)
        this.getLocationExist(this.form.companyOwner)
        this.getCompanyLocation(this.form.companyOwner)
      }
    }
  },

  mounted () {
    this.getCompanyOwner()
    this.getWorkUnit()
  },

  methods: {
    getReduceValue: ({ value }) => value,
    getReduceName: ({ name }) => name,
    getWorkUnitName: ({ workUnitName }) => workUnitName,
    getReduceId: ({ id }) => id,
    getOrganizationSelectable: ({ group }) => !group,
    getCompanyLabel ({ name }) {
      return this.$t(`company-detail.company.${name}`)
    },
    previousPage () {
      this.$router.go(-1)
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      localStorage.clear()
      this.$router.replace({
        path: '/'
      })
    },
    async getCompanyOwner () {
      const dataCompanyOwner = await Api.masterData.companies()
      this.dataApi.companyOwner = dataCompanyOwner.data.data
      this.dataApi.companyOwner.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    async getCompanyName (id) {
      const dataCompanyName = await Api.masterData.contractors({
        Filters: `companyId==${id || ''}`
      })
      this.dataApi.companyName = dataCompanyName.data.data
      this.dataApi.companyName.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      if (!this.dataApi.companyName.length) {
        this.form.companyName = ''
      }
    },
    async getCompanyLocation (id) {
      const { data } = await Api.masterData.workLocationsExist({
        Filters: [`companyId==${id || ''}`, 'IsOrganization==true'].join(',')
      })
      this.dataApi.companyLocation = data.data
      if (!this.dataApi.companyLocation.length) {
        this.form.companyLocation = ''
      }
    },
    async getLocationExist (id) {
      const { data } = await Api.masterData.workLocations({
        Filters: `companyId==${id || ''}`
      })
      this.dataApi.locationExist = data.data.reduce((acc, curr) => {
        const newGroup = (!acc.find(a => a.group === curr.category) &&
          [{ group: curr.category, name: null }]) ||
          []
        return [
          ...acc,
          ...newGroup,
          curr
        ]
      }, [])
      if (!this.dataApi.locationExist.length) {
        this.form.locationExist = ''
      }
    },
    async getWorkUnit () {
      const dataWorkUnit = await Api.getWorkUnit()
      this.dataApi.workUnit = dataWorkUnit.data.data
      this.dataApi.workUnit.sort((a, b) => (a.workUnitName > b.workUnitName) ? 1 : ((b.workUnitName > a.workUnitName) ? -1 : 0))
    },
    async submitForm () {
      this.loadingSubmit = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const registration = JSON.parse(localStorage.getItem('Registration'))
        const personalData = JSON.parse(localStorage.getItem('PersonalData'))
        const HRISAccount = JSON.parse(localStorage.getItem('HRISAccount'))
        let formRegister = null
        if (HRISAccount) {
          formRegister = {
            id: HRISAccount.id,
            roleId: HRISAccount.roleId,
            username: HRISAccount.username,
            email: HRISAccount.email,
            isActiveDirectory: HRISAccount.isActiveDirectory
          }
        }
        if (registration) {
          formRegister = {
            username: registration.username,
            email: registration.email,
            password: registration.password
          }
        }
        if (personalData) {
          formRegister.fullname = personalData.fullname
          formRegister.gender = personalData.gender
          formRegister.birthdate = personalData.dateBirth
          formRegister.address = personalData.address
          formRegister.phoneNumber = personalData.phonenumber
        }
        formRegister.companyGroup = this.company
        formRegister.language = this.$i18n.locale.toUpperCase()
        if (this.company !== 'BOC (Board of Commisioner)') {
          formRegister.nric = this.form.nik
          formRegister.companyId = this.form.companyOwner
          if (this.form.locationExist) {
            formRegister.workLocationActual = this.form.locationExist
          }
          if (this.form.workUnit) {
            formRegister.workUnit = this.form.workUnit
          }
          if (this.form.companyName) {
            formRegister.contractorId = this.form.companyName
          }
          if (this.form.companyLocation) {
            formRegister.workLocationId = this.form.companyLocation
          }
          if (this.form.pcr64) {
            formRegister.pcrSwabTest = this.form.pcr64
          }
          if (this.form.visitDate) {
            formRegister.visitDate = this.form.visitDate
          }
        }
        if (HRISAccount) {
          const dataPost = await Api.postHrisAccount(formRegister)
          if (dataPost.data.status === 2001) {
            localStorage.HRISAccount = JSON.stringify(dataPost.data.data)
            this.$router.push({
              name: 'success-register'
            })
          } else {
            this.textModal = dataPost.data.message.messageEng
            this.showModal('unsuccessful')
          }
        }
        if (registration) {
          const data = await Api.auth.register(formRegister)
          if (data.status === 201) {
            this.$router.push({
              name: 'success-register'
            })
          } else {
            this.modal.textModal = data.data.message.messageEng
            this.showModal('unsuccessful')
          }
        }
      }
      this.loadingSubmit = false
    },
    onFileChange (e) {
      const file = e.target.files[0]
      this.form.pcr = URL.createObjectURL(file)
      this.selectedFile = this.$refs.file.files[0]
      this.createBase64(file)
    },
    createBase64 (fileObject) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.form.pcr64 = e.target.result
      }
      reader.readAsDataURL(fileObject)
    }
  },

  validations: {
    company: {
      required
    },
    form: {
      nik: {
        required,
        maxLength: maxLength(25)
      },
      companyOwner: {
        required: requiredIf(function () {
          return (this.company !== 'BOC (Board of Commisioner)' && this.company !== '')
        })
      },
      companyLocation: {
        required: requiredIf(function () {
          return (this.company !== 'BOC (Board of Commisioner)' && this.company !== '')
        })
      },
      workUnit: {
        required: requiredIf(function () {
          return (this.company === 'ITM Group') || (this.company === 'Vendor') || (this.company === 'Contractor')
        })
      },
      locationExist: {
        required: requiredIf(function () {
          return (this.company !== 'BOC (Board of Commisioner)' && this.company !== '')
        })
      },
      visitDate: {
        required: requiredIf(function () {
          return (this.company === 'Guest')
        })
      },
      pcr64: {
        required: requiredIf(function () {
          return (this.company === 'Guest')
        })
      }
    }
  }
}
</script>

<style scoped>
.content {
  background-image: url("~@/assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}
.white-box {
  background: white;
  min-width: 404px;
  border-radius: 18px;
}
.dynamic-form {
  min-height: 400px;
}
.text-one {
  color: #121212;
  font-family: Montserrat;
  font-size: 19px;
  line-height: 24px;
  text-align: left;
}
.text-two {
  color: #18b2bd;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 17px;
  text-align: left;
  font-weight: 600;
  padding-bottom: 30px;
  border-bottom: 1px solid #dedede;
}
.form-group > label,
.form-group > div > label {
  font-size: 12px;
  font-weight: bold;
}

.button > div > .previous {
  background-color: white;
  border: 2px solid #18b2bd;
  color: #18b2bd;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: 0.5s;
}
.button > div > .next {
  background-color: #18b2bd;
  border: 2px solid #18b2bd;
  color: white;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: 0.5s;
}
.button > div > .next:hover {
  background-color: #18b2bdbd;
  border: 2px solid #18b2bdbd;
}
.button > div > .previous:hover {
  background-color: #e6e6e6bd;
}
.text-dropdown,
.text-input {
  font-weight: 400;
  font-size: 12px;
  color: black;
  height: 32px;
}
.pointer {
  cursor: pointer;
}
input[type="file"] {
  display: none;
}
</style>
